import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStatus } from '@/shared/hooks/useAuth';
import { LoadingScreen } from '@/shared/components/feedback/LoadingScreen';
import { ROUTES } from './paths';

/**
 * Gate for authenticated areas. While the session is being restored (idle/
 * loading) we show a splash; unauthenticated users are sent to /login with the
 * attempted location preserved for post-login return.
 */
export function ProtectedRoute() {
  const status = useAuthStatus();
  const location = useLocation();

  if (status === 'idle' || status === 'loading') {
    return <LoadingScreen label="Restoring session…" />;
  }
  if (status === 'unauthenticated') {
    return <Navigate to={ROUTES.login} replace state={{ from: location }} />;
  }
  return <Outlet />;
}
